module.exports = __webpack_public_path__ + "static/img/egg_b_03.d257877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_03.png
// module id = xxQL
// module chunks = 1